// Top branded header stub.
//
// Placeholder. Detailed styling comes from Codex's design pass. Keep the
// brand mark strictly capital X: "100X EQUINE".
import type { ReactNode } from 'react';

export function Header(): ReactNode {
  return (
    <header
      role="banner"
      aria-label="100X Equine Sales Workspace header"
      style={{
        borderBottom: '1px solid #d0d0d0',
        padding: '12px 20px',
        fontWeight: 600,
      }}
    >
      100X EQUINE / Sales Workspace
    </header>
  );
}
